<template>
  <div class="phone-edit-container">
    <el-card class="edit-card" shadow="never">
      <div slot="header" class="card-header">
        <div class="header-title">
          <h2>{{ $t("changePhone") }}</h2>
          <el-button icon="el-icon-back" type="text" @click="goBack">
            {{ $t("back") }}
          </el-button>
        </div>
      </div>

      <el-form
        ref="phoneForm"
        :model="phoneForm"
        :rules="rules"
        label-width="120px"
        class="phone-form"
      >
        <el-form-item :label="$t('currentPhone')" prop="currentPhone">
          <el-input
            v-model="phoneForm.currentPhone"
            disabled
            :placeholder="$t('currentPhone')"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('newPhone')" prop="newPhone">
          <el-input
            v-model="phoneForm.newPhone"
            :placeholder="$t('pleaseInputNewPhone')"
            @keyup.enter.native="handleSubmit"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('verifyCode')" prop="code">
          <div class="code-container">
            <el-input
              v-model="phoneForm.code"
              :placeholder="$t('pleaseInputVerifyCode')"
              style="margin-right: 10px"
              @keyup.enter.native="handleSubmit"
            ></el-input>
            <el-button
              size="nomal"
              :disabled="isSending"
              @click="getCode"
              :class="isSending ? 'sending' : ''"
            >
              {{ countDownText }}
            </el-button>
          </div>
        </el-form-item>

        <el-form-item>
          <el-button
            size="nomal"
            type="primary"
            @click="handleSubmit"
            :loading="loading"
          >
            {{ $t("save") }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "PhoneEdit",
  data() {
    return {
      userId: "",
      phoneForm: {
        currentPhone: "",
        newPhone: "",
        code: "",
      },
      rules: {
        currentPhone: [
          {
            required: true,
            message: this.$t("pleaseInputCurrentPhone"),
            trigger: "blur",
          },
        ],
        newPhone: [
          {
            required: true,
            message: this.$t("pleaseInputNewPhone"),
            trigger: "blur",
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: this.$t("pleaseInputValidPhone"),
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: this.$t("pleaseInputVerifyCode"),
            trigger: "blur",
          },
        ],
      },
      loading: false,
      countDown: 60,
      isSending: false,
      timer: null,
    };
  },
  computed: {
    countDownText() {
      return this.isSending
        ? `${this.countDown}${this.$t("resendAfter")}`
        : this.$t("getVerifyCode");
    },
  },
  created() {
    // 从cookies获取用户信息
    const userInfo = this.$cookies.get("userInfo");
    if (userInfo) {
      this.userId = userInfo.userid;
      this.phoneForm.currentPhone = userInfo.phone;
    }

    // 从路由参数获取手机号(如果有)
    if (this.$route.query.phone) {
      this.phoneForm.newPhone = this.$route.query.phone;
    }
  },
  beforeDestroy() {
    // 组件销毁时清除定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },

    // 获取验证码
    getCode() {
      console.log("获取验证码");
      if (!this.phoneForm.newPhone) {
        this.$message.error(this.$t("pleaseInputNewPhoneFirst"));
        return;
      }

      if (!/^1[3-9]\d{9}$/.test(this.phoneForm.newPhone)) {
        this.$message.error(this.$t("pleaseInputValidPhone"));
        return;
      }

      if (this.phoneForm.currentPhone == this.phoneForm.newPhone) {
        this.$message.error(this.$t("phoneNoNeedChange"));
        return;
      }

      this.isSending = true;
      this.countDown = 60;

      // 发送获取验证码请求
      this.$get("/send_phone_code", {
        mobile: this.phoneForm.newPhone,
      })
        .then((res) => {
          if (res.data.code === 1) {
            this.$message.success(this.$t("codeSent"));
            this.startCountDown();
          } else {
            this.$message.error(res.data.msg);
            this.isSending = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(this.$t("getCodeFailedRetry"));
          this.isSending = false;
        });
    },

    // 开始倒计时
    startCountDown() {
      this.timer = setInterval(() => {
        this.countDown--;
        if (this.countDown <= 0) {
          clearInterval(this.timer);
          this.isSending = false;
          this.countDown = 60;
        }
      }, 1000);
    },

    // 保存修改
    handleSubmit() {
      this.$refs.phoneForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$post("/update_phone", {
            userid: this.userId,
            phone: this.phoneForm.newPhone,
            smsCode: this.phoneForm.code,
          })
            .then((res) => {
              if (res.data.code === 1) {
                this.$message.success(this.$t("phoneChangeSuccess"));
                // 更新cookies中的手机号
                const userInfo = this.$cookies.get("userInfo");
                if (userInfo) {
                  userInfo.phone = this.phoneForm.newPhone;
                  this.$cookies.set("userInfo", userInfo);
                }
                // 返回上一页
                setTimeout(() => {
                  this.$router.go(-1);
                }, 1000);
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch((err) => {
              console.log(err);
              this.$message.error(this.$t("changeFailedRetry"));
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          console.log("验证失败");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.phone-edit-container {
  width: 100%;
  box-sizing: border-box;
}

.edit-card {
  border: none;
}

::v-deep .edit-card .el-card__body {
  max-width: 500px;
}

::v-deep .el-input--small .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

::v-deep .el-card__header {
  padding: 0px 16px;
}

.header-title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-title ::v-deep .el-button--small {
  font-size: 14px;
}

.header-title span {
  font-weight: bold;
  font-size: 18px;
  margin-right: 10px;
}

.phone-form {
  width: 100%;
}

.code-container {
  display: flex;
  align-items: center;
}

.sending {
  background-color: #dcdfe6;
  color: #606266;
  cursor: not-allowed;
}

/* 手机端适配 */
@media (max-width: 768px) {
  .phone-edit-container {
    padding: 15px;
  }

  .edit-card {
    max-width: 100%;
  }

  .code-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .code-container .el-input {
    width: 100%;
    margin-bottom: 10px;
  }

  .code-container .el-button {
    width: 100%;
  }
}
</style>
